import { render, staticRenderFns } from "./CoverVideo.vue?vue&type=template&id=79bf2149&"
import script from "./CoverVideo.vue?vue&type=script&lang=js&"
export * from "./CoverVideo.vue?vue&type=script&lang=js&"
import style0 from "./CoverVideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports